// Modules
import { useFormContext } from "react-hook-form"

// Constants
import { REGEX } from "~constants/regex"

// Components
import Input from "~app/Input"
import { WizardRow, WizardColumn, WizardStepContainer } from "~styled/wizard"

interface StepProps {
  isVisible: boolean
}

const PerkModalStep4ExternalLink = ({ isVisible = true }: StepProps) => {
  const { register } = useFormContext()

  return (
    <WizardStepContainer className={isVisible ? "visible" : ""}>
      <WizardRow style={{ marginBottom: 30 }}>
        <WizardColumn>
          <Input
            name="redeemResource"
            label="*External link"
            register={register("redeemResource", {
              required: true,
              validate: (value: string) => REGEX.URL.test(value),
            })}
          />
        </WizardColumn>
      </WizardRow>
    </WizardStepContainer>
  )
}

export default PerkModalStep4ExternalLink
